import { createStandardAxios } from './utils/ajax';

const api = createStandardAxios();

export async function getAssetUuidFromAssetId(assetId: number) {
  return (await api.get<string>('/Assets/GetAssetUuidFromAssetId', { params: { assetId } })).data;
}
